"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapApiToUserInfo = exports.mapApiToLau = void 0;
const mapApiToLau = (apiLau) => {
    return {
        id: apiLau.lau,
        obec: apiLau.nazev,
        okres: apiLau.okres_nazev,
        kraj: apiLau.kraj_nazev
    };
};
exports.mapApiToLau = mapApiToLau;
const mapApiToUserInfo = (userInfo) => {
    return {
        id: userInfo.sub,
        phone: userInfo.phone,
        email: userInfo.email,
        firstName: userInfo.firstName,
        surname: userInfo.surname,
    };
};
exports.mapApiToUserInfo = mapApiToUserInfo;
